export enum ExpandableCollapsableComponent {
  ReweighLogDetailsComponent,
  ShipmentDimensions,
  HeaderHistory,
  DetailsHist,
  ScaleTests


}
